exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-status-center[data-v-3f12fd78]{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n#queueSelect[data-v-3f12fd78]{\n    width: 200px !important\n}\n.card[data-v-3f12fd78] {\n    max-width: 320px;\n}\n.cards-container[data-v-3f12fd78] {\n    display: flex;\n    min-width: 650px;\n    max-height: 650px;\n    flex-wrap: wrap;\n    justify-content: space-around;\n}\n\n", ""]);

// exports
